module.exports = __webpack_public_path__ + "img/5-11-year.cd54abcd.png";